import squer_box from "../../asset/images/squery.png"
import cvPath from "../../asset/images/brijesh.pdf"

import React from "react";
export default function Brijesh() {
    const styles = {
        main: {
            backgroundImage: "../../images/squery.png",
            height: "450px",
            width: "450px",
        }
    }
    const download = () => {
        const link = document.createElement('a');
        link.href = `${cvPath}`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    return (
            <div className={"container-fluid paddingForHeading"}>
                <div className={"row brijesh_wrapper"}>
                    <div className={"col-lg-7 section_title_main"}>
                        <h2 className={"section_title"}>I am Brijesh</h2>
                        <div className={"discriptions ps-5"}>As a creative frontend developer, I am dedicated to delivering high-quality user experiences that are visually appealing, functional, and responsive.</div>
                        <a 
                            className={"download_cv mt-5 ms-5"}
                            href="../../asset/images/Brijesh.pdf"
                            target="_blank"
                            onClick={() => download()}
                        >
                            <button type="button">Download - CV</button>
                        </a>
                    </div>
                    <div className={`col-lg-5 px-0 d-lg-block d-none image_main`}>
                        <div className={"images_squer"}>
                            <img src={squer_box} className={"image_squer"} alt="about Brijesh"/>
                        </div>
                    </div>
                </div>
            </div>
    )
}